// Product packaging images used by the interactive catalog.
window.__resources = window.__resources || {
  "packaging-sensory-touch-22": "//www.natpat.com/cdn/shop/files/lp-homepage-v2-sensory-touch-22_1024x1024.png?v=116348",
  "packaging-kids-tick-48": "//www.natpat.com/cdn/shop/files/lp-homepage-v2-kids-tick-48_1024x1024.png?v=14599329514700637083",
  "packaging-bedtime-24": "//www.natpat.com/cdn/shop/files/lp-homepage-v2-bedtime-24_1024x1024.png?v=9726114225490047067",
  "packaging-pet-flea-repellent-24": "//www.natpat.com/cdn/shop/files/lp-homepage-v2-pet-flea-repellent-24_1024x1024.png?v=17231311644140966486",
  "packaging-uv-24": "//www.natpat.com/cdn/shop/files/lp-homepage-v2-uv-24_1024x1024.png?v=11564357990510668158",
  "packaging-zen-24": "//www.natpat.com/cdn/shop/files/lp-homepage-v2-zen-24_1024x1024.png?v=8020838875440680037",
  "packaging-breathe-easy-24": "//www.natpat.com/cdn/shop/files/lp-homepage-v2-breathe-easy-24_1024x1024.png?v=2915071117356892725",
  "packaging-pet-tick-48": "//www.natpat.com/cdn/shop/files/lp-homepage-v2-pet-tick-48_1024x1024.png?v=18230533625244431244",
  "packaging-new-buzzpatch-60": "//www.natpat.com/cdn/shop/files/lp-homepage-v2-new-buzzpatch-60_1024x1024.png?v=16810483313530135712",
  "packaging-adult-buzzpatch-40": "//www.natpat.com/cdn/shop/files/lp-homepage-v2-adult-buzzpatch-40_1024x1024.png?v=8796656196905227782",
  "packaging-itch-relief-32": "//www.natpat.com/cdn/shop/files/lp-homepage-v2-itch-relief-32_1024x1024.png?v=1916325939716648213",
  "packaging-dog-training-aid-24": "//www.natpat.com/cdn/shop/files/lp-homepage-v2-dog-training-aid-24_1024x1024.png?v=13442644583181809863",
  "packaging-focus-24": "//www.natpat.com/cdn/shop/files/lp-homepage-v2-focus-24_1024x1024.png?v=2136822565177693051",
  "packaging-pet-zen-24": "//www.natpat.com/cdn/shop/files/lp-homepage-v2-pet-zen-24_1024x1024.png?v=6482914996428216169",
  "packaging-adult-bedtime-24": "//www.natpat.com/cdn/shop/files/lp-homepage-v2-adult-bedtime-24_1024x1024.png?v=5646708528393775213",

  "packaging-bedtime-pack": "//www.natpat.com/cdn/shop/files/lp-homepage-v2-bedtime-pack_1024x1024.png?v=6026314250120818167",
  "packaging-zen-pack": "//www.natpat.com/cdn/shop/files/lp-homepage-v2-zen-pack_1024x1024.png?v=2170872126997413943",
  "packaging-new-buzzpatch-pack": "//www.natpat.com/cdn/shop/files/lp-homepage-v2-new-buzzpatch-pack_1024x1024.png?v=14439648884301792816",
  "packaging-kids-tick-pack": "//www.natpat.com/cdn/shop/files/lp-homepage-v2-kids-tick-pack_1024x1024.png?v=4492782710450592825",
  "packaging-pet-zen-pack": "//www.natpat.com/cdn/shop/files/lp-homepage-v2-pet-zen-pack_1024x1024.png?v=3002695968788425970",

  "sleep-icon": "//www.natpat.com/cdn/shop/files/lp-homepage-v2-sleep-icon_1024x1024.png?v=16035560338255842195",
  "calm-icon": "//www.natpat.com/cdn/shop/files/lp-homepage-v2-calm-icon_1024x1024.png?v=16388772534624183048",
  "outdoors-icon": "//www.natpat.com/cdn/shop/files/lp-homepage-v2-outdoors-icon_1024x1024.png?v=12365143299724873815",
  "tick-defence-icon": "//www.natpat.com/cdn/shop/files/lp-homepage-v2-tick-defence-icon_1024x1024.png?v=2509480052958381425",
  "pets-icon": "//www.natpat.com/cdn/shop/files/lp-homepage-v2-pets-icon_1024x1024.png?v=2427819679128239970",

  "cedarwood": "//www.natpat.com/cdn/shop/files/lp-homepage-v2-cedarwood_1024x1024.png?v=6889417457074215975",
  "citronella": "//www.natpat.com/cdn/shop/files/lp-homepage-v2-citronella_1024x1024.png?v=7491267586582837742",
  "clary-sage": "//www.natpat.com/cdn/shop/files/lp-homepage-v2-clary-sage_1024x1024.png?v=7305410122223401246",
  "coconut-oil": "//www.natpat.com/cdn/shop/files/lp-homepage-v2-coconut-oil_1024x1024.png?v=15862318603534814787",
  "eucalyptus": "//www.natpat.com/cdn/shop/files/lp-homepage-v2-eucalyptus_1024x1024.png?v=4844022607444687169",
  "geranium": "//www.natpat.com/cdn/shop/files/lp-homepage-v2-geranium_1024x1024.png?v=11210698491612306977",
  "citronella": "//www.natpat.com/cdn/shop/files/lp-homepage-v2-citronella_1024x1024.png?v=7491267586582837742",
  "geraniol": "//www.natpat.com/cdn/shop/files/lp-homepage-v2-geraniol_1024x1024.png?v=10496789776018610553",
  "lavender": "//www.natpat.com/cdn/shop/files/lp-homepage-v2-lavender_1024x1024.png?v=4301321270002490241",
  "lemongrass": "//www.natpat.com/cdn/shop/files/lp-homepage-v2-lemongrass_1024x1024.png?v=10549934132463858647",
  "mandarin": "//www.natpat.com/cdn/shop/files/lp-homepage-v2-mandarin_1024x1024.png?v=16568841917637048368",
  "orange": "//www.natpat.com/cdn/shop/files/lp-homepage-v2-orange_1024x1024.png?v=9828421423550048869",
  "peppermint": "//www.natpat.com/cdn/shop/files/lp-homepage-v2-peppermint_1024x1024.png?v=1866580287173550640",
  "sweet-marjoram": "//www.natpat.com/cdn/shop/files/lp-homepage-v2-sweet-marjoram_1024x1024.png?v=18180455553466752024",
  "thyme": "//www.natpat.com/cdn/shop/files/lp-homepage-v2-thyme_1024x1024.png?v=1204156776015584603",
  "vetiver": "//www.natpat.com/cdn/shop/files/lp-homepage-v2-vetiver_1024x1024.png?v=6261298065238017555",

  "sarah": "//www.natpat.com/cdn/shop/files/lp-homepage-v2-sarah-cover_1024x1024.jpg?v=7582031816149904092",
  "mike": "//www.natpat.com/cdn/shop/files/lp-homepage-v2-mike-cover_1024x1024.jpg?v=14850359292731458541",
  "rachel": "//www.natpat.com/cdn/shop/files/lp-homepage-v2-rachel-cover_1024x1024.jpg?v=280648683112559798",

  "james": "//www.natpat.com/cdn/shop/files/lp-homepage-v2-james-t-cover_1024x1024.jpg?v=5089660993012164704",
  "lisa": "//www.natpat.com/cdn/shop/files/lp-homepage-v2-lisa-p-cover_1024x1024.jpg?v=507992936981911483",
  "anna": "//www.natpat.com/cdn/shop/files/lp-homepage-v2-anna-w-cover_1024x1024.jpg?v=10319558031695589084",

  "david": "//www.natpat.com/cdn/shop/files/lp-homepage-v2-david-r-cover_1024x1024.jpg?v=17733122302458872893",
  "michelle": "//www.natpat.com/cdn/shop/files/lp-homepage-v2-michelle-b-cover_1024x1024.jpg?v=7050308324419284522",
  "tom": "//www.natpat.com/cdn/shop/files/lp-homepage-v2-tom-h-cover_1024x1024.jpg?v=17867410198223358027",

  "karen": "//www.natpat.com/cdn/shop/files/lp-homepage-v2-karen-l-cover_1024x1024.jpg?v=1123123747997796890",
  "ryan": "//www.natpat.com/cdn/shop/files/lp-homepage-v2-ryan-s-cover_1024x1024.jpg?v=4545892001875424008",
  "nicole": "//www.natpat.com/cdn/shop/files/lp-homepage-v2-nicole-f-cover_1024x1024.jpg?v=10609960641617441637",

  "chris": "//www.natpat.com/cdn/shop/files/lp-homepage-v2-chris-m-cover_1024x1024.jpg?v=15728713656167702209",
  "emily": "//www.natpat.com/cdn/shop/files/lp-homepage-v2-emily-r-cover_1024x1024.jpg?v=5031096289478575865",
  "mark": "//www.natpat.com/cdn/shop/files/lp-homepage-v2-mark-t-cover_1024x1024.jpg?v=8443588649730645934",
};

// ═════════════════════════════════════════════════════════
// NATPAT homepage — interactive layer
// ═════════════════════════════════════════════════════════

// ─── HERO SLIDER ───
const hSlides = document.querySelectorAll('.h-slide');
const hDots = document.getElementById('hdots');
let hCur = 0, hTimer;

hSlides.forEach((_, i) => {
  const d = document.createElement('button');
  d.className = 'hdot' + (i === 0 ? ' on' : '');
  d.setAttribute('aria-label', 'Go to slide ' + (i + 1));
  d.onclick = () => { hGo(i); resetTimer(); };
  hDots.appendChild(d);
});
function hGo(n) {
  hSlides[hCur].classList.remove('on');
  hDots.children[hCur].classList.remove('on');
  hCur = (n + hSlides.length) % hSlides.length;
  hSlides[hCur].classList.add('on');
  hDots.children[hCur].classList.add('on');
}
function heroNav(d) { hGo(hCur + d); resetTimer(); }
function resetTimer() { clearInterval(hTimer); hTimer = setInterval(() => hGo(hCur + 1), 7000); }
resetTimer();


window.CURRENT_VARIANT_ID = null;
window.CURRENT_SELLING_PLAN_ID = null;

window.CURRENT_COLOR = null;
window.CURRENT_PACK_NUM = null;
const ZERO_BITES_ID = "ultimate-mosquito-repellent-bundle"
const KIDS_LICE_ID = 'kids-lice-repelling-hairbands';
const PET_LOCKET_ID = "pet-locket"

const colorSwatches = {
  "black": "#23242a",
  "navy": "#2c3f77", 
  "white": "#f4f2ec"
};

let curCat = 'featured-outdoor';
//console.log('Initial category:', window.CAT);
// function renderChips(c) {
//   const el = document.getElementById('pdp-chips'), prods = window.CAT[c];
//   el.innerHTML = prods.map((p, i) =>
//     `<button class="pchip${i === 0 ? ' on' : ''}" data-pack-id="${p.id}" onclick="selP(this,'${c}',${i})">${p.nm}${p.tag ? `<span class="chip-tag">${p.tag}</span>` : ''}</button>`
//   ).join('');
//   updProd(prods[0], c);
//   console.log(window.CAT[c]);
//   // New js
//   // updateVariant();
//   updatePrice(document.querySelector('.qtier.on'));
// }
const topProductsMap = {
  'outdoor-protection': 'buzzpatch-bundles',
};

function renderChips(c) {
  const el = document.getElementById('pdp-chips');
  let prods = window.CAT[c]; 

  const targetProductId = topProductsMap[c]; 

  if (targetProductId) {
    const targetIndex = prods.findIndex(p => p.id === targetProductId);

    if (targetIndex > 0) {
      const [specificProduct] = prods.splice(targetIndex, 1);
      prods.unshift(specificProduct);
    }
  }

  el.innerHTML = prods.map((p, i) =>
    `<button class="pchip${i === 0 ? ' on' : ''}" data-pack-id="${p.id}" onclick="selP(this,'${c}',${i})">${p.nm}${p.tag ? `<span class="chip-tag">${p.tag}</span>` : ''}</button>`
  ).join('');
  
  updProd(prods[0], c);
  //console.log(window.CAT[c]);
  
  // New js
  updatePrice(document.querySelector('.qtier.on'));
}
function swCat(el, c) {
  document.querySelectorAll('.ctab').forEach(t => t.classList.remove('on'));
  el.classList.add('on'); curCat = c; renderChips(c);
}
function selP(el, c, i) {
  document.querySelectorAll('.pchip').forEach(x => x.classList.remove('on'));
  el.classList.add('on'); updProd(CAT[c][i], c);

  // New js
  updateVariant();
  const variantEl = el.closest('.pdp-info').querySelector('.qtier.on');
  if (variantEl) updatePrice(variantEl);
}


function updProd(p, c) {
  document.getElementById('pdp-tt').innerHTML = p.tt;
  document.getElementById('pdp-sub').textContent = p.sub;
  // If Zero Bite product info badge text
  const pdpCountTextEl = document.getElementById('pdp-count-text');
  const pdpCountOtherTextEl = document.getElementById('pdp-count-other-text');
  const pdpSl = document.querySelectorAll('.pdp-sl');
  if(p.id === ZERO_BITES_ID) {
    document.querySelector('.pdp-count svg').style.display = 'none';
    pdpCountTextEl.textContent = `🧳 10 defenses in one treasure case`;
    pdpCountOtherTextEl.textContent = `· Limited edition · Sealed packs last up to 24 months`;
    document.getElementById('pbo-overlay-2').style.display = 'block';
  }else if(p.id === KIDS_LICE_ID) {
      document.querySelector('.pdp-count svg').style.display = 'inline-block';
      pdpCountTextEl.textContent = `${p.patchesCount || 24} hairbands per pack`;
      pdpCountOtherTextEl.textContent = `· Sealed for freshness · Lasts 12 months`;
      document.getElementById('pbo-overlay-2').style.display = 'none';
  } else if (p.id === PET_LOCKET_ID) {
    document.querySelector('.pdp-count svg').style.display = 'inline-block';
    pdpCountTextEl.textContent = `1 locket per pack`;
    pdpCountOtherTextEl.textContent = `· Clips to any collar · Reusable`;
    document.getElementById('pbo-overlay-2').style.display = 'none';
  } else {
    document.querySelector('.pdp-count svg').style.display = 'inline-block';
    pdpCountTextEl.textContent = `${p.patchesCount || 24} stickers per pack`;
    pdpCountOtherTextEl.textContent = `· Sealed for freshness · Lasts 12 months`;
    document.getElementById('pbo-overlay-2').style.display = 'none';
  }
  const listItems = p.bn?.children?.[0]?.children || [];
  const cleanCheckmarks = listItems.map(item => {
    return item.children?.[0]?.value || '';
  });
  document.getElementById('pdp-bl').innerHTML = cleanCheckmarks.map(b => `<li><span class="ck"><svg viewBox="0 0 24 24"><path d="M4 12l5 5 11-11"/></svg></span> ${b}</li>`).join('');
  document.getElementById('pdp-rating').textContent = p.rat + ' · 1M+ customers';
  document.getElementById('stars-container').innerHTML = `
  <span class="stars-bg">★★★★★</span>
  <span class="stars-fg" style="width: ${p.ratingsPercentage}%;">★★★★★</span>
  `;
  // update main pack shot
  let btnImages = ``;
  // alternate images
  if (p.alternateImages && p.alternateImages.length > 0) {
    p.alternateImages.forEach((imgSrc, idx) => {
      if (imgSrc) {
        btnImages += `<button class="pdp-th ${idx === 0 ? 'on' : ''}" data-th="${idx}" onclick="pdpSl(${idx})"><img src="${imgSrc}" alt="" loading="lazy" decoding="async"></button>`
      }
    })
    document.querySelectorAll('.pdp-sl')[0].querySelector('img.pack').setAttribute('src', p.alternateImages[0]);
  } else {
    btnImages = `
          <button class="pdp-th on" data-th="0" onclick="pdpSl(0)"><img src="${p.pack}" alt="" loading="lazy" decoding="async"></button>
          <button class="pdp-th" data-th="1" onclick="pdpSl(1)"><img src="//www.natpat.com/cdn/shop/files/character-01_1024x1024.png?v=11255877076927812230" alt="" loading="lazy" decoding="async"></button>
          <button class="pdp-th" data-th="2" onclick="pdpSl(2)"><img src="//www.natpat.com/cdn/shop/files/character-05_1024x1024.png?v=4672622643961795077" alt="" loading="lazy" decoding="async"></button>
          <button class="pdp-th" data-th="3" onclick="pdpSl(3)"><img src="//www.natpat.com/cdn/shop/files/character-02_1024x1024.png?v=12731388697641476737" alt="" loading="lazy" decoding="async"></button>
      `
    document.querySelectorAll('.pdp-sl')[0].querySelector('img.pack').setAttribute('src', p.pack);
  }
  document.querySelectorAll('.pdp-sl').forEach(s => s.classList.remove('on'));
  document.querySelectorAll('.pdp-sl')[0].classList.add('on');
  document.querySelector('.pdp-ths').innerHTML = btnImages;

  // overlay text
  const listItemsCustomBadges = p.customBadges?.children?.[0]?.children || [];

  const cleanCustomBadges = listItemsCustomBadges.map(item => {
    return item.children?.[0]?.value || '';
  });
  document.getElementById('pbo-overlay').innerHTML = cleanCustomBadges.map(b => `<div class="pbo-i">
    <span class="pbo-ic">
       <svg viewBox="0 0 24 24"><path d="M12 2C8 6 6 9 6 13a6 6 0 0 0 12 0c0-4-2-7-6-11z"></path></svg>
    </span>
    <span class="pbo-t">${b}</span>
    </div>`).join('');

  // const isPets = c === 'pets', isAdult = c === 'adults';
  // document.getElementById('pbo-safe').textContent = p.safe || (isPets ? 'Safe for dogs and cats' : 'Safe for kids and families');
  // document.getElementById('pbo-love').textContent = p.love || (isPets ? 'Pets stay calmer' : 'Kids ask for them');
  // ingredients accordion
  // document.getElementById('acc-ing').textContent = p.acc || '';
  // sticky bar
  document.getElementById('sb-name').textContent = p.tt.replace(/<[^>]+>/g, '').trim();
  document.getElementById('sb-pack-img').src = p.pack;


  // New js
  updateVariant();
}

// New js
function updateVariant() {
  const currentPackEl = document.querySelector('.pchip.on');
  const prods = window.CAT[curCat];
  const currentPackObj = prods.find(p => p.id === currentPackEl.dataset.packId);
  const patchesCount = currentPackObj.patchesCount || 0;

  if (!currentPackObj.variants) {
    document.querySelector('.qty-tiers').innerHTML = 'No variants available';
    document.querySelector('.qty-tiers').style.display = 'block';
    return;
  }

  document.querySelector('.qty-tiers').style.display = 'grid';
  const currentPurchaseType = document.querySelector('.pdp-info').getAttribute('data-purchase-type');

  // --- TARGET SPECIFIC PRODUCT ---
  const isLiceHairbands = currentPackObj.id === KIDS_LICE_ID;
  let variantsToRender = currentPackObj.variants;

  const colorLbl = document.getElementById('color-lbl');
  const colorContainer = document.getElementById('color-swatches');

  if (isLiceHairbands) {
    const uniqueColors = [...new Set(currentPackObj.variants.map(v => v.variantName).filter(Boolean))];

    if (uniqueColors.length > 0) {
      if (colorLbl) colorLbl.style.display = 'block';
      if (colorContainer) {
        colorContainer.style.display = 'flex';
        
        if (!window.CURRENT_COLOR || !uniqueColors.includes(window.CURRENT_COLOR)) {
          window.CURRENT_COLOR = uniqueColors[0];
        }

        colorContainer.innerHTML = uniqueColors.map(color => {
          const cleanColor = color.toLowerCase().trim();
          const hex = colorSwatches[cleanColor] || '#DDDDDD';
          const isActive = color === window.CURRENT_COLOR;
          const ringColor = isActive ? '#1434C9' : 'transparent';
          const textColor = isActive ? '#1434C9' : '#1A234A';
          
          return `
            <div class="color-swatch-item" onclick="selColor('${color.replace(/'/g, "\\'")}')" style="display: flex; flex-direction: column; align-items: center; cursor: pointer; user-select: none;">
              <div class="swatch-outer" style="width: 54px; height: 54px; border-radius: 50%; border: 3px solid ${ringColor}; display: flex; align-items: center; justify-content: center; margin-bottom: 8px; transition: all 0.2s ease;">
                <div class="swatch-inner" style="display: block; width: 40px; height: 40px; border-radius: 50%; background-color: ${hex}; border: 2px solid ${cleanColor === 'white' ? '#EAEAEA' : hex}; box-sizing: border-box; box-shadow: 0 1px 3px rgba(0,0,0,0.1);"></div>
              </div>
              <span style="font-size: 13px; font-weight: 800; color: ${textColor}; text-transform: uppercase; letter-spacing: 0.5px;">${color}</span>
            </div>
          `;
        }).join('');
      }

      variantsToRender = currentPackObj.variants.filter(v => v.variantName === window.CURRENT_COLOR);
    }
  } else {
    if (colorLbl) colorLbl.style.display = 'none';
    if (colorContainer) colorContainer.style.display = 'none';
    window.CURRENT_COLOR = null;
  }

  let defaultActiveVariant;

  if (isLiceHairbands) {
    //Try to keep their previous pack selection
    defaultActiveVariant = variantsToRender.find(v => parseInt(v.realPackNum) === parseInt(window.CURRENT_PACK_NUM));
    //Fallback to pack 3
    if (!defaultActiveVariant) defaultActiveVariant = variantsToRender.find(v => parseInt(v.realPackNum) === 3);
    //Fallback to the last available variant if 3 doesn't exist
    if (!defaultActiveVariant) defaultActiveVariant = variantsToRender[variantsToRender.length - 1];
  } else {
    //Try to find Pack 3
    defaultActiveVariant = variantsToRender.find(v => parseInt(v.packNum) === 3);
    //Fallback to the last available variant if 3 doesn't exist
    if (!defaultActiveVariant) defaultActiveVariant = variantsToRender[variantsToRender.length - 1];
  }

  const activeVariantId = defaultActiveVariant ? defaultActiveVariant.variantId : null;

  // --- RENDER QUANTITY TIERS ---
  document.querySelector('.qty-tiers').innerHTML = variantsToRender.map(v => {
    
    let displayName;
    const isActiveTier = v.variantId === activeVariantId;

    if (isLiceHairbands) {
      displayName = v.realPackNum;
    } else {
      displayName = (
        v.variantName &&
        !v.variantName.toLowerCase().includes('pack') &&
        !v.variantName.toLowerCase().includes('default title')
      ) ? `${v.realPackNum} - ${v.variantName}` : v.realPackNum;
    }

    return `<div class="qtier ${v.realPackNum === 3 ? 'best' : ''} ${isActiveTier ? 'on' : ''}" 
   data-id="${v.variantId}"
   data-real-pack="${v.realPackNum}"
   data-original-price="${v.originalPrice}" 
   data-onetime-price="${v.oneTimePrice}" 
   data-subscription-price="${v.subscriptionPrice}"
   data-save-subscription="${v.priceSaveSubscription}"
   data-save-onetime="${v.priceSaveOneTime}"
   data-patches-count="${patchesCount * v.realPackNum}"
   data-percent-off="${v.percentOff || 0}" onclick="selQty(this)">
    <div class="qtier-n">${displayName}</div>
    <div class="qtier-l">${currentPackObj.id === ZERO_BITES_ID ? 'Case' : 'Pack'}${v.realPackNum > 1 ? 's' : ''}</div>
    <div class="qtier-p">${window.CURRENCY}${currentPurchaseType === 'subscription' ? v.pricePerEachSubscription : v.pricePerEachOneTime}${v.realPackNum > 1 ? `<div class="qtier-per">/each</div>` : ''}</div>
    </div>`
  }).join('');

  setTimeout(() => {
    const activeTier = document.querySelector('.qtier.on') || document.querySelector('.qtier');
    if (activeTier) {
      updatePrice(activeTier);
    }
  }, 10);
}

function selColor(colorName) {
  window.CURRENT_COLOR = colorName;
  updateVariant();
}

function updateAddToCartPrice() {
  const currentPurchaseType = document.querySelector('.pdp-info').getAttribute('data-purchase-type');
  const currentVariantEl = document.querySelector('.qtier.on');
  const savePriceEl = document.querySelector('.save-line strong');
  let price = ''
  let savePrice = ''
  window.CURRENT_VARIANT_ID = currentVariantEl ? currentVariantEl.getAttribute('data-id') : '';

  if (!currentVariantEl) return;
  if (currentPurchaseType === 'subscription') {
    price = currentVariantEl.getAttribute('data-subscription-price');
    savePrice = currentVariantEl.getAttribute('data-save-subscription');
    window.CURRENT_SELLING_PLAN_ID = document.querySelector('.freq-sel').value;
  }
  if (currentPurchaseType === 'onetime') {
    price = currentVariantEl.getAttribute('data-onetime-price');
    savePrice = currentVariantEl.getAttribute('data-save-onetime');
    window.CURRENT_SELLING_PLAN_ID = null;
  }


  document.querySelector('.btn-atc .btn-atc-price').textContent = `${window.CURRENCY}${price}`;
  savePriceEl.textContent = savePrice ? `${window.CURRENCY}${savePrice}` : '';
}
const updateStickerCount = (count) => {
  const el = document.getElementById('pdp-count-text');
  if (el) el.textContent = `${count} stickers per pack`;
}
function updatePurchaseType() {
  const el = document.querySelector('.oc.on');
  const dataType = el.getAttribute('data-type');
  document.querySelector('.pdp-info').setAttribute('data-purchase-type', dataType);
}

function updateSellingPlan() {
  const sel = document.querySelector('.freq-sel');
  const tier = document.querySelector('.qtier.on');
  const productEl = document.querySelector('.pchip.on');
  const product = window.CAT[curCat].find(p => p.id === productEl.dataset.packId);
  const variant = product.variants.find(v => String(v.variantId) === tier.dataset.id);
  // Preserve the subscription provider and labels configured in Liquid,
  // while only offering plans allocated to the selected variant.
  const allocatedPlanIds = new Set((variant.sellingPlans || []).map(plan => String(plan.id)));
  const plans = (product.sellingPlans || []).filter(plan => allocatedPlanIds.has(String(plan.id)));
  const previousPlan = sel.value;
  sel.innerHTML = '';
  plans.forEach(plan => {
    const opt = document.createElement('option');
    opt.value = plan.id;
    opt.textContent = plan.name;
    sel.appendChild(opt);
  });
  const selected = plans.find(plan => String(plan.id) === previousPlan)
    || plans.find(plan => plan.name.includes('7 weeks')) || plans[0];
  if (selected) sel.value = selected.id;

  const subscription = document.querySelector('.oc[data-type="subscription"]');
  subscription.style.display = plans.length ? 'block' : 'none';
  if (!plans.length) {
    subscription.classList.remove('on');
    document.querySelector('.oc[data-type="onetime"]').classList.add('on');
  }
  updatePurchaseType();
  document.getElementById('freq-row').style.display = subscription.classList.contains('on') ? 'block' : 'none';
}

function updatePrice(el) {
  if (!el) return;
  updateSellingPlan();
  const onetimePrice = el.getAttribute('data-onetime-price');
  const subscriptionPrice = el.getAttribute('data-subscription-price');
  const originalPrice = el.getAttribute('data-original-price');
  const percentOff = el.getAttribute('data-percent-off');
  const patchesCount = el.getAttribute('data-patches-count');

  const onetimeOption = document.querySelector('.oc[data-type="onetime"]');
  const subscriptionOption = document.querySelector('.oc[data-type="subscription"]');
  subscriptionOption.querySelector('.oc-now').textContent = `${window.CURRENCY}${subscriptionPrice}`;
  subscriptionOption.querySelector('.oc-was').textContent = `${window.CURRENCY}${onetimePrice}`;
  onetimeOption.querySelector('.oc-now').textContent = `${window.CURRENCY}${onetimePrice}`;
  onetimeOption.querySelector('.oc-was').textContent = `${window.CURRENCY}${originalPrice}`;
  onetimeOption.querySelector('.oc-off').textContent = `${percentOff}% off`;

  updateAddToCartPrice();
}
// ============
function selQty(el) {
  document.querySelectorAll('.qtier').forEach(x => x.classList.remove('on'));
  el.classList.add('on');

  // New js
  updatePrice(el);
}
function selOff(el, type) {
  document.querySelectorAll('.oc').forEach(c => c.classList.remove('on'));
  el.classList.add('on');
  document.getElementById('freq-row').style.display = type === 'sub' ? 'block' : 'none';

  // New js
  updatePurchaseType()
  updateVariant();
  const variantEl = el.closest('.pdp-info').querySelector('.qtier.on');
  if (variantEl) updatePrice(variantEl);
}
document.querySelector('.freq-sel').addEventListener('change', function () {
  window.CURRENT_SELLING_PLAN_ID = this.value;
})
async function addToCart() {
  if (!window.CURRENT_VARIANT_ID) {
    console.error('No variant selected');
    return;
  }
  const btn = document.querySelector('#btn-atc');
  const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  btn.textContent = 'Adding...';
  btn.disabled = true;
  btn.style.backgroundColor = '#f0bfb1';
  btn.style.cursor = 'not-allowed';
  btn.style.borderColor = '#1f1f5b4d';
  btn.style.boxShadow = 'unset';
  btn.style.pointerEvents = 'none';
  try {
    const body = {
      id: window.CURRENT_VARIANT_ID,
      quantity: 1,
    };

    if (window.CURRENT_SELLING_PLAN_ID) {
      body.selling_plan = window.CURRENT_SELLING_PLAN_ID;
    }

    if (cart) {
      body.sections = cart.getSectionsToRender().map((section) => section.id).join(',');
      body.sections_url = window.location.pathname;
      cart.setActiveElement(document.activeElement);
    }

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    config.body = JSON.stringify(body);

    const res = await fetch(`${routes.cart_add_url}`, config);
    const response = await res.json();

    if (response.status) {
      console.error('Add to cart error:', response.description);
      return;
    }

    if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'lp-homepage-v2',
        productVariantId: window.CURRENT_VARIANT_ID,
        cartData: response,
      });
    }

    if (typeof window.prepareDataForDisplayWidgetByRule === 'function') {
      window.prepareDataForDisplayWidgetByRule();
    } else if (cart) {
      cart.renderContents(response);
      if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
    } else {
      window.location = window.routes.cart_url;
    }

  } catch (err) {
    console.error('Add to cart error:', err);
  } finally {
    const currentPurchaseType = document.querySelector('.pdp-info').getAttribute('data-purchase-type');
    const currentVariantEl = document.querySelector('.qtier.on');
    const price = currentVariantEl ? (currentPurchaseType === 'subscription' ? currentVariantEl.getAttribute('data-subscription-price') : currentVariantEl.getAttribute('data-onetime-price')) : '';
    btn.innerHTML = `
          Add to cart · <span class="btn-atc-price">${window.CURRENCY}${price}</span>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 6l6 6-6 6"></path></svg>
    `;
    btn.disabled = false;
    btn.style.backgroundColor = 'var(--np-coral)';
    btn.style.cursor = 'pointer';
    btn.style.border = '3px solid var(--np-deep-blue)';
    btn.style.boxShadow = 'var(--shadow-sticker)';
    btn.style.pointerEvents = 'auto';
  }
}
document.querySelector('#btn-atc').addEventListener('click', addToCart);

// init
renderChips('featured-outdoor');

// PDP gallery thumbs
function pdpSl(n) {
  document.querySelectorAll('.pdp-sl').forEach(s => s.classList.remove('on'));
  document.querySelectorAll('.pdp-th').forEach(t => t.classList.remove('on'));
  document.querySelectorAll('.pdp-sl')[n].classList.add('on');
  document.querySelectorAll('.pdp-th')[n].classList.add('on');
  const img = document.querySelectorAll('.pdp-th')[n].querySelector('img').getAttribute('src');
  const mainImg = document.querySelectorAll('.pdp-sl')[n].querySelector('img.pack').setAttribute('src', img);
}

// ─── REVIEWS DATA ───
const REVS = {
  0: [
    { t: 'Bedtime went from an hour to fifteen minutes', p: 'My daughter used to fight bedtime. Now she asks for her sticker. Three months in, still working.', a: 'Sarah M.', city: 'Austin, TX', img: window.__resources['sarah'] },
    { t: 'Finally sleeping past 6am', p: 'Our four-year-old was up at 5am daily. A week of SleepyPatch and she\'s sleeping until 6:30. We have our mornings back.', a: 'Mike D.', city: 'Seattle, WA', img: window.__resources['mike'] },
    { t: 'No more melatonin gummy battles', p: 'A sticker on his pyjamas, he thinks it\'s cool, I get the same result. Wish I\'d found this two kids ago.', a: 'Rachel K.', city: 'Brooklyn, NY', img: window.__resources['rachel'] },
  ],
  1: [
    { t: 'Camping trip, three kids, zero bites', p: 'We used to douse everyone in DEET. The patches are so much easier — the kids actually remind us to put them on.', a: 'James T.', city: 'Bend, OR', img: window.__resources['james'] },
    { t: 'Backyard summer, restored', p: 'Moved to Texas and the mosquitoes were a daily problem. BuzzPatch changed that. We can be outside again.', a: 'Lisa P.', city: 'Houston, TX', img: window.__resources['lisa'] },
    { t: 'Better than every spray we tried', p: 'No sticky residue, no chemical smell. Just a fun sticker. My 6-year-old calls it her "bug shield."', a: 'Anna W.', city: 'Brisbane, AU', img: window.__resources['anna'] },
  ],
  2: [
    { t: 'Homework without the meltdown', p: 'FocusPatch before homework has become our routine. He sits, he works, no tears. We can\'t go back.', a: 'David R.', city: 'Chicago, IL', img: window.__resources['david'] },
    { t: 'His teacher noticed', p: 'Two weeks in his teacher emailed asking what had changed. That said it all.', a: 'Michelle B.', city: 'Denver, CO', img: window.__resources['michelle'] },
    { t: 'Screen-time transitions, easier', p: 'Getting him off the iPad used to be a battle. The patch helps him shift gears without the drama.', a: 'Tom H.', city: 'Toronto, ON', img: window.__resources['tom'] },
  ],
  3: [
    { t: 'School drop-off without tears', p: 'ZenPatch on her collar before school. The crying stopped within a week. She walks in smiling.', a: 'Karen L.', city: 'Sydney, AU', img: window.__resources['karen'] },
    { t: 'Calmer in a meltdown', p: 'When my son starts spiraling, the patch helps bring him back. Not instant magic, but real.', a: 'Ryan S.', city: 'Portland, OR', img: window.__resources['ryan'] },
    { t: 'Dentist visits, survivable', p: 'She used to scream at the dentist. ZenPatch 30 minutes before — she sat through the whole appointment.', a: 'Nicole F.', city: 'Boston, MA', img: window.__resources['nicole'] },
  ],
  4: [
    { t: 'Thunderstorm anxiety, gone', p: 'Our rescue dog used to hide under the bed during storms. Pet Zen on his collar and he sleeps through them.', a: 'Chris M.', city: 'Nashville, TN', img: window.__resources['chris'] },
    { t: 'Vet visits without the shaking', p: 'Our cat would shake the entire car ride. Pet Zen made a real difference — she was calm the whole visit.', a: 'Emily R.', city: 'Phoenix, AZ', img: window.__resources['emily'] },
    { t: 'Separation anxiety, easier', p: 'We put Pet Zen on before leaving for work. The destruction stopped. Total game changer.', a: 'Mark T.', city: 'Glasgow, UK', img: window.__resources['mark'] },
  ],
};
function swRT(el, i) {
  document.querySelectorAll('.rtab').forEach(t => t.classList.remove('on'));
  el.classList.add('on');
  const g = document.getElementById('rev-grid');
  g.innerHTML = REVS[i].map((r, j) => `
    <div class="rc2">
    <img src="${r.img}" alt="" />
    <div class="rc2-content">
      <span class="stars">★★★★★</span>
      <h4>${r.t}</h4>
      <p>${r.p}</p>
      <div class="auth">
        <span class="auth-av a${j % 3}">${r.a[0]}</span>
        <div>
          <div class="auth-name">${r.a}</div>
          <div class="auth-verif"><svg viewBox="0 0 24 24"><path d="M4 12l5 5 11-11"/></svg> Verified · ${r.city}</div>
        </div>
      </div>
    </div>
    </div>
  `).join('');
}
swRT(document.querySelector('.rtab.on'), 0);

// ─── ACCORDIONS ───
function tAcc(b) {
  const i = b.parentElement, o = i.classList.contains('op');
  document.querySelectorAll('.pacc-i').forEach(x => x.classList.remove('op'));
  if (!o) i.classList.add('op');
}
function tFaq(b) {
  const i = b.parentElement, o = i.classList.contains('op');
  document.querySelectorAll('.faq-i').forEach(x => x.classList.remove('op'));
  if (!o) i.classList.add('op');
}

// ─── COUNT-UP STATS ───
let statsDone = false;
function countUp() {
  if (statsDone) return; statsDone = true;
  document.querySelectorAll('.sn').forEach(el => {
    const target = parseFloat(el.dataset.target),
      suffix = el.dataset.suffix || '',
      dec = parseInt(el.dataset.decimal) || 0,
      big = target >= 1000;
    let cur = 0; const step = target / (big ? 60 : 40);
    const timer = setInterval(() => {
      cur += step;
      if (cur >= target) { cur = target; clearInterval(timer); }
      if (big) el.textContent = (cur >= 1000000 ? (cur / 1000000).toFixed(0) + 'M' : Math.floor(cur).toLocaleString()) + suffix;
      else el.textContent = (dec ? cur.toFixed(dec) : Math.floor(cur)) + suffix;
    }, 30);
  });
}

// ─── SCROLL ───
const obs = new IntersectionObserver(es => {
  es.forEach(e => { if (e.isIntersecting) e.target.classList.add('v'); });
}, { threshold: .1 });
document.querySelectorAll('.reveal').forEach(el => obs.observe(el));

const statsObs = new IntersectionObserver(es => {
  es.forEach(e => { if (e.isIntersecting) countUp(); });
}, { threshold: .3 });
const statsEl = document.getElementById('stats-section');
if (statsEl) statsObs.observe(statsEl);

const sBar = document.getElementById('sticky-bar');
const pdpEl = document.getElementById('pdp-section');
const stickyObs = new IntersectionObserver(es => {
  es.forEach(e => { sBar.classList.toggle('show', !e.isIntersecting && e.boundingClientRect.top < 0); });
}, { threshold: 0 });
if (pdpEl) stickyObs.observe(pdpEl);

// ─── ORBITAL: 5 products, each with its own 6 ingredients ───
const ORB = [
    {
    id: 'buzz', pack: window.__resources['packaging-new-buzzpatch-pack'],
    icon: window.__resources['outdoors-icon'],
    label: 'For outdoors', count: '218,000+',
    ings: [
      { n: 'Citronella', d: 'Bug-repelling, plant-based', c: 'pink-np', img: window.__resources['citronella'] },
      { n: 'Geraniol', d: 'Natural mosquito deterrent', c: 'orange-np', img: window.__resources['geraniol'] },
      { n: 'Lemongrass', d: 'Fresh, insect-repelling', c: 'blue-np', img: window.__resources['lemongrass'] },
      { n: 'Peppermint', d: 'Cooling, bug-repelling', c: 'yellow-np', img: window.__resources['peppermint'] },
      { n: 'Eucalyptus', d: 'Strong natural repellent', c: 'purple-np', img: window.__resources['eucalyptus'] },
      { n: 'Coconut Oil', d: 'Carrier oil base', c: 'green-np', img: window.__resources['coconut-oil'] },
    ]
  },
  {
    id: 'sleepy', pack: window.__resources['packaging-bedtime-pack'],
    icon: window.__resources['sleep-icon'],
    label: 'For sleep', count: '129,797',
    ings: [
      { n: 'Mandarin', d: 'Mood-lifting, soothing', c: 'pink-np', img: window.__resources['mandarin'] },
      { n: 'Lavender', d: 'Calming, sleep-supporting', c: 'orange-np', img: window.__resources['lavender'] },
      { n: 'Sweet Marjoram', d: 'Natural sleep cycles', c: 'blue-np', img: window.__resources['sweet-marjoram'] },
      { n: 'Vetiver', d: 'Grounding, deep calm', c: 'yellow-np', img: window.__resources['vetiver'] },
      { n: 'Coconut Oil', d: 'Gentle carrier base', c: 'purple-np', img: window.__resources['coconut-oil'] },
      { n: 'Cedarwood', d: 'Warm, relaxing', c: 'green-np', img: window.__resources['cedarwood'] },
    ]
  },
  {
    id: 'zen', pack: window.__resources['packaging-zen-pack'],
    icon: window.__resources['calm-icon'],
    label: 'For calm', count: '121,007',
    ings: [
      { n: 'Mandarin', d: 'Relaxation, comfort', c: 'pink-np', img: window.__resources['mandarin'] },
      { n: 'Sweet Orange', d: 'Mood-lifting, uplifting', c: 'orange-np', img: window.__resources['orange'] },
      { n: 'Atlas Cedarwood', d: 'Warm, grounding', c: 'blue-np', img: window.__resources['cedarwood'] },
      { n: 'Lavender', d: 'Calming, stress relief', c: 'yellow-np', img: window.__resources['lavender'] },
      { n: 'Vetiver', d: 'Deep calm, grounding', c: 'purple-np', img: window.__resources['vetiver'] },
      { n: 'Coconut Oil', d: 'Gentle carrier base', c: 'green-np', img: window.__resources['coconut-oil'] },
    ]
  },
  {
    id: 'trail', pack: window.__resources['packaging-kids-tick-pack'],
    icon: window.__resources['tick-defence-icon'],
    label: 'For tick defence', count: '35,060',
    ings: [
      { n: 'Peppermint', d: 'Tick-repelling, cooling', c: 'pink-np', img: window.__resources['peppermint'] },
      { n: 'Geranium', d: 'Natural tick deterrent', c: 'orange-np', img: window.__resources['geranium'] },
      { n: 'Thyme', d: 'Strong protective oil', c: 'blue-np', img: window.__resources['thyme'] },
      { n: 'Cedarwood', d: 'Repels ticks & insects', c: 'yellow-np', img: window.__resources['cedarwood'] },
      { n: 'Vetiver', d: 'Grounding, protective', c: 'purple-np', img: window.__resources['vetiver'] },
      { n: 'Coconut Oil', d: 'Carrier oil base', c: 'green-np', img: window.__resources['coconut-oil'] },
    ]
  },
  {
    id: 'petzen', pack: window.__resources['packaging-pet-zen-pack'],
    icon: window.__resources['pets-icon'],
    label: 'For pets', count: '22,320',
    ings: [
      { n: 'Lavender', d: 'Calming, anxiety relief', c: 'pink-np', img: window.__resources['lavender'] },
      { n: 'Orange', d: 'Uplifting, soothing', c: 'orange-np', img: window.__resources['orange'] },
      { n: 'Clary Sage', d: 'Stress-reducing, balancing', c: 'blue-np', img: window.__resources['clary-sage'] },
      { n: 'Geranium', d: 'Calming, skin-safe', c: 'yellow-np', img: window.__resources['geranium'] },
      { n: 'Vetiver', d: 'Grounding, deep calm', c: 'purple-np', img: window.__resources['vetiver'] },
      { n: 'Coconut Oil', d: 'Pet-safe carrier oil', c: 'green-np', img: window.__resources['coconut-oil'] },
    ]
  },
];

const orbPack = document.getElementById('orb-pack');
const orbLabel = document.getElementById('orb-label');
const orbCountN = document.getElementById('orb-count-n');
const orbDotsHost = document.getElementById('orb-dots');
const orbOils = document.querySelectorAll('.orb-oil');

if (orbPack && orbOils.length === 6) {
  // build selector dots
  ORB.forEach((p, i) => {
    const b = document.createElement('button');
    b.className = 'orb-dot' + (i === 0 ? ' on' : '');
    b.setAttribute('role', 'tab');
    b.setAttribute('aria-label', p.label);
    b.innerHTML = `<img src="${p.icon}" alt=""><span>${p.label.replace(/^For /, '')}</span>`;
    b.onclick = () => { renderOrb(i); resetOrbTimer(); };
    orbDotsHost.appendChild(b);
  });

  let oi = 0;
  function renderOrb(i) {
    oi = i;
    // crossfade out
    orbPack.classList.add('orb-swap');
    orbLabel.classList.add('orb-swap');
    orbOils.forEach(el => el.classList.add('orb-swap'));
    setTimeout(() => {
      const p = ORB[i];
      orbPack.src = p.pack;
      orbLabel.textContent = p.label;
      if (orbCountN) orbCountN.textContent = p.count;
      orbOils.forEach((el, j) => {
        const ing = p.ings[j];
        if (!ing) return;
        el.className = 'orb-oil c-' + ing.c;
        el.style.setProperty('--a', getOrbAngle(j));
        el.querySelector('.orb-drop').innerHTML = `<img src="${ing.img}" alt="${ing.n}">`;
        el.querySelector('.orb-name').textContent = ing.n;
        el.querySelector('.orb-desc').textContent = ing.d;
      });
      orbDotsHost.querySelectorAll('.orb-dot').forEach((d, k) => d.classList.toggle('on', k === i));
      // crossfade in
      orbPack.classList.remove('orb-swap');
      orbLabel.classList.remove('orb-swap');
      orbOils.forEach(el => el.classList.remove('orb-swap'));
    }, 280);
  }
  function getOrbAngle(pos) {
    // 6 positions clockwise from top, offset so layout matches brief
    // 0 top-left, 1 top-right, 2 left, 3 right, 4 bottom-left, 5 bottom-right
    return ['300deg', '60deg', '270deg', '90deg', '240deg', '120deg'][pos];
  }

  let orbTimer;
  function startOrbTimer() {
    orbTimer = setInterval(() => renderOrb((oi + 1) % ORB.length), 2000);
  }
  function resetOrbTimer() { clearInterval(orbTimer); startOrbTimer(); }

  // initial render
  renderOrb(0);
  startOrbTimer();

  // pause on hover
  const orbHost = document.querySelector('.orb');
  if (orbHost) {
    orbHost.addEventListener('mouseenter', () => clearInterval(orbTimer));
    orbHost.addEventListener('mouseleave', startOrbTimer);
  }
}

// ─── UGC CAROUSEL SCROLL ───
window.ugcScroll = function (d) {
  const t = document.getElementById('ugc-track');
  if (!t) return;
  const card = t.querySelector('.ugc-c');
  const step = card ? card.getBoundingClientRect().width + 16 : 220;
  t.scrollBy({ left: d * step * 2, behavior: 'smooth' });
};

// ─── BUNDLE SLIDER ───
const bTrack = document.getElementById('btrack');
if (bTrack) {
  const bSlides = bTrack.children;
  const bTotal = bSlides.length;
  let bCur = 0;
  const bDotsC = document.getElementById('bdots');
  for (let i = 0; i < bTotal; i++) {
    const d = document.createElement('button');
    d.className = 'slider-dot' + (i === 0 ? ' on' : '');
    d.setAttribute('aria-label', 'Go to bundle ' + (i + 1));
    d.onclick = () => bGo(i);
    bDotsC.appendChild(d);
  }
  window.bGo = function (n) {
    bCur = (n + bTotal) % bTotal;
    bTrack.style.transform = `translateX(-${bCur * 100}%)`;
    bDotsC.querySelectorAll('.slider-dot').forEach((d, i) => d.classList.toggle('on', i === bCur));
    document.getElementById('bcur').textContent = bCur + 1;
  };
  window.bNav = function (d) { bGo(bCur + d); };
  let touchX = 0;
  bTrack.addEventListener('touchstart', e => { touchX = e.touches[0].clientX; }, { passive: true });
  bTrack.addEventListener('touchend', e => {
    const diff = touchX - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 50) diff > 0 ? bNav(1) : bNav(-1);
  }, { passive: true });
}

// ─── CUSTOM VIDEO PLAYERS ───
const players = document.querySelectorAll('.custom-player');

const videoElCount = document.querySelector('.ugc-count').innerHTML = `· ${players.length} stories &amp; counting`;

function formatTime(seconds) {
  if (isNaN(seconds)) return '0:00';
  const mins = Math.floor(seconds / 60);
  const secs = Math.floor(seconds % 60);
  return `${mins}:${secs < 10 ? '0' : ''}${secs}`;
}

// ─── Lazy metadata loader ──────────────────────────────────────────────────
const metaObserver = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (!entry.isIntersecting) return;

    const wrapper = entry.target;
    const video = wrapper.querySelector('.video-element');

    // Already loaded or has a hard-coded duration — no need to fetch metadata
    if (video.dataset.metaLoaded || video.dataset.duration) {
      metaObserver.unobserve(wrapper);
      return;
    }

    video.querySelectorAll('source').forEach(source => {
      if (source.dataset.src) {
        source.src = source.dataset.src;
      }
    });

    video.preload = 'metadata';
    video.load();

    video.addEventListener('loadedmetadata', () => {
      video.dataset.metaLoaded = 'true';

      const timeDisplay = wrapper.querySelector('.time-display');
      const topDuration = wrapper.querySelector('.top-duration');
      const formatted = formatTime(video.duration);

      if (timeDisplay) timeDisplay.textContent = `0:00 / ${formatted}`;
      if (topDuration) topDuration.textContent = formatted;

      metaObserver.unobserve(wrapper);
    }, { once: true });
  });
}, {
  rootMargin: '200px'
});

const pauseObserver = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    const video = entry.target.querySelector('.video-element');
    if (!entry.isIntersecting && !video.paused) {
      video.pause();
    }
  });
}, {
  threshold: 0.2
});

players.forEach(wrapper => {
  pauseObserver.observe(wrapper);
  const video = wrapper.querySelector('.video-element');
  const initialUi = wrapper.querySelector('.initial-ui');
  const centerBtn = wrapper.querySelector('.center-btn');
  const playIcon = wrapper.querySelector('.play-icon');
  const pauseIcon = wrapper.querySelector('.pause-icon');
  const controlsBar = wrapper.querySelector('.controls-bar');
  const progressBar = wrapper.querySelector('.progress-bar');
  const timeDisplay = wrapper.querySelector('.time-display');
  const fullscreenBtn = wrapper.querySelector('.fullscreen-btn');
  const topDuration = wrapper.querySelector('.top-duration');
  const bgColor = wrapper.querySelector('.ugc-bg');

  let isVideoPlayedOnce = false;
  let inactivityTimeout;

  metaObserver.observe(wrapper);

  function initializeTimeDisplay() {
    const hardcodedSeconds = parseInt(video.getAttribute('data-duration'), 10);
    if (hardcodedSeconds && !isNaN(hardcodedSeconds)) {
      const formattedTotalTime = formatTime(hardcodedSeconds);
      timeDisplay.textContent = `0:00 / ${formattedTotalTime}`;
      if (topDuration) topDuration.textContent = formattedTotalTime;
    }
  }

  initializeTimeDisplay();

  video.addEventListener('loadedmetadata', () => {
    if (video.duration) {
      const actualTime = formatTime(video.duration);
      timeDisplay.textContent = `0:00 / ${actualTime}`;
      if (topDuration) topDuration.textContent = actualTime;
    }
  });

  // ── Playback ─────────────────────────────────────────────────────────────
  function togglePlay() {
    if (video.paused || video.ended) {
      if (!video.dataset.metaLoaded && !video.src) {
        video.querySelectorAll('source').forEach(source => {
          if (source.dataset.src) source.src = source.dataset.src;
        });
        video.load();
      }
      document.querySelectorAll('.video-element').forEach(v => {
        if (v !== video) v.pause();
      });
      video.play();
    } else {
      video.pause();
    }
  }

  video.addEventListener('play', () => {
    if (!isVideoPlayedOnce) isVideoPlayedOnce = true;
    initialUi.classList.add('playing-hide');
    bgColor.style.opacity = '0';
    controlsBar.classList.add('active');
    playIcon.style.display = 'none';
    pauseIcon.style.display = 'block';
    resetInactivityTimeout();
  });

  video.addEventListener('pause', () => {
    initialUi.classList.remove('playing-hide');
    playIcon.style.display = 'block';
    playIcon.style.marginLeft = '4px';
    pauseIcon.style.display = 'none';
    bgColor.style.opacity = '.5';
    controlsBar.classList.remove('active');
    showControls();
    clearTimeout(inactivityTimeout);
  });

  video.addEventListener('ended', () => {
    playIcon.style.display = 'block';
    playIcon.style.marginLeft = '4px';
    pauseIcon.style.display = 'none';
    showControls();
    clearTimeout(inactivityTimeout);
  });

  centerBtn.addEventListener('click', togglePlay);
  video.addEventListener('click', togglePlay);

  video.addEventListener('timeupdate', () => {
    if (!video.duration) return;
    const progressPercent = (video.currentTime / video.duration) * 100;
    progressBar.value = progressPercent;
    progressBar.style.background =
      `linear-gradient(to right, #ffffff ${progressPercent}%, rgba(255,255,255,0.3) ${progressPercent}%)`;
    timeDisplay.textContent =
      `${formatTime(video.currentTime)} / ${formatTime(video.duration)}`;
  });

  progressBar.addEventListener('input', (e) => {
    if (!video.duration) return;
    video.currentTime = (e.target.value / 100) * video.duration;
  });

  // fullscreenBtn.addEventListener('click', () => {
  //   if (!document.fullscreenElement) {
  //     (wrapper.requestFullscreen      ||
  //      wrapper.webkitRequestFullscreen ||
  //      wrapper.msRequestFullscreen    ).call(wrapper);
  //   } else {
  //     (document.exitFullscreen      ||
  //      document.webkitExitFullscreen).call(document);
  //   }
  // });

  fullscreenBtn.addEventListener('click', () => {
    if (video.webkitEnterFullscreen) {
      video.webkitEnterFullscreen();
      return;
    }

    if (!document.fullscreenElement) {
      (wrapper.requestFullscreen ||
        wrapper.webkitRequestFullscreen ||
        wrapper.msRequestFullscreen).call(wrapper);
    } else {
      (document.exitFullscreen ||
        document.webkitExitFullscreen).call(document);
    }
  });

  function showControls() {
    centerBtn.classList.remove('fade-out');
    controlsBar.classList.remove('fade-out');
  }

  function hideControls() {
    if (!video.paused && isVideoPlayedOnce) {
      centerBtn.classList.add('fade-out');
      controlsBar.classList.add('fade-out');
    }
  }

  function resetInactivityTimeout() {
    showControls();
    clearTimeout(inactivityTimeout);
    inactivityTimeout = setTimeout(hideControls, 2500);
  }

  wrapper.addEventListener('mousemove', resetInactivityTimeout);
  wrapper.addEventListener('touchstart', resetInactivityTimeout);
  wrapper.addEventListener('mouseleave', hideControls);


});


// Clinician 
const toggleBtnDocCta = document.getElementById("toggleBtnDocCta");
  const clinicianContent = document.getElementById("clinicianContent");
const arrowIcon = toggleBtnDocCta.querySelector(".arrow-icon");
toggleBtnDocCta.addEventListener("click", function(event) {
  event.preventDefault(); 
  clinicianContent.classList.toggle("hidden");
  arrowIcon.classList.toggle("rotate-90");
});